import React from 'react';  
import './index.css';
import {Icon} from 'antd'
import { ActionSheet,  Toast } from 'antd-mobile';
import {
    Link
} from 'react-router-dom'; 
import {
        Douban,
        Facebook,
        Google,
        Qq,
        Qzone,        
        Twitter,
        Weibo,
        Linkedin,
        TencentWB,        
        BaiduPostBar,
        Email,
        Wx
    } from 'share-react'
 
const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault(),
  };
}

const shareicon = {
  QqIcon : function(){
              return(
                <Qq  style={{ width: 36 }} >
                  <img src={'https://gw.alipayobjects.com/zos/rmsportal/SxpunpETIwdxNjcJamwB.png'} alt='' style={{ width: 36 }} />
                </Qq>
              )
           }, 
  QzoneIcon : function(){
                return(
                <Qzone  style={{ width: 36 }} >
                  <img src={'https://gw.alipayobjects.com/zos/rmsportal/cTTayShKtEIdQVEMuiWt.png'} alt='' style={{ width: 36 }} />
                </Qzone>
                )
              },

  WeiboIcon : function(){
                return(
                  <Weibo  style={{ width: 36 }} >
                    <img src={'https://gw.alipayobjects.com/zos/rmsportal/wvEzCMiDZjthhAOcwTOu.png'} alt='' style={{ width: 36 }} />
                  </Weibo>
                )
              }
  }

class InfoBottom extends React.Component{
    constructor(props) {
    super(props);
    this.state = {
      clicked: 'none', 
    };

  }
 
  handleLike(){
    this.props.recordClick(this.state.like)
  }
 
 
 
  dataList = [
      {  title: 'QQ' ,icon:shareicon.QqIcon()},
      {  title: '新浪微博',icon:shareicon.WeiboIcon() },
      {  title: 'QQ空间' ,icon:shareicon.QzoneIcon()},
    ].map(obj => ({
      icon: obj.icon,
      title: obj.title,
    }));
  showShareActionSheet = () => {
    ActionSheet.showShareActionSheetWithOptions({
      options: this.dataList,
      message: '分享到',
    },
    (buttonIndex) => {
      this.setState({ clicked1: buttonIndex > -1 ? this.dataList[buttonIndex].title : 'cancel' });
      // also support Promise
      return new Promise((resolve) => {
        setTimeout(resolve, 1000);
      });
    });
  }


  render(){
    return (
        <div className="info-bottom">
          <div className="bottom-icon-box">
            {/*<div className="bottom-actions">*/}
              {/*<div className="bottom-icon"  onClick={()=>{this.handleLike()}}>*/}
               {/*<Icon type="heart" theme={this.props.collect?'filled':null}/>*/}
              {/*</div> */}
            {/*</div>*/}
            {/*<div className="bottom-actions">*/}
            {/*  <div className="bottom-icon" onClick={this.showShareActionSheet}>*/}
            {/*    <img src={require('./img/icon_share.png')} alt=""/>*/}
            {/*  </div>*/}
            {/*</div> */}
        </div>
        <div className="enter-btn">
          <Link  to={`/courseliveinfo/${this.props.id}`}>
           进入直播
          </Link>
        </div>
       </div>
      )
  }
}
export default InfoBottom;